import * as React from 'react';
import { observer } from 'mobx-react';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import {
    personaCardBehavior,
    PersonaCardBehaviorProps,
} from 'owa-persona/lib/components/PersonaCardBehavior';

const styles = require('./GroupPicture.scss');

export interface GroupPictureProps {
    name: string;
    emailAddress: string;
    clientScenario: string;
    size: PersonaSize;
}

@observer
export default class GroupPicture extends React.Component<GroupPictureProps, any> {
    render() {
        const personaProps = {
            name: this.props.name,
            emailAddress: this.props.emailAddress,
            personaType: 'Group',
            clientScenario: this.props.clientScenario,
            size: this.props.size,
        };
        return <GroupPicturePersona {...personaProps} />;
    }
}

export interface GroupPicturePersonaProps extends PersonaCardBehaviorProps {
    size: PersonaSize;
}

@personaCardBehavior
class GroupPicturePersona extends React.Component<GroupPicturePersonaProps, React.ComponentState> {
    render(): any {
        return (
            <PersonaControl
                className={styles.groupPicture}
                name={this.props.name}
                emailAddress={this.props.emailAddress}
                size={this.props.size}
            />
        );
    }
}
